export default __webpack_public_path__ + "static/media/tree.c75a3c75.PNG";